/* This file was generated automatically. Do not edit manually. */

export enum OnboardingAuditArea {
    Tasks = 'Tasks',
    Users = 'Users',
    Companies = 'Companies',
    Services = 'Services',
    Rates = 'Rates',
    PropertySettings = 'PropertySettings',
    FinancialSettings = 'FinancialSettings',
    GuestExperience = 'GuestExperience',
    AdditionalServices = 'AdditionalServices',
    BookableServices = 'BookableServices',
    Marketplace = 'Marketplace',
    KycStatus = 'KycStatus',
    UnpaidInvoices = 'UnpaidInvoices',
    Spaces = 'Spaces',
    InitialSetUp = 'InitialSetUp',
}
